<template>
  <div>
    <SysDialog
      v-model="dialog"
      :largura="470"
      titulo="Estoque de segurança por fornecedor"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="$emit('fechar-dialog-fornecedor', false)"
    >
      <TextFieldFormatadorDeValor
        v-if="cobertura_selecionada === 3"
        v-model="cobertura_esseg"
        label="Informe a cobertura do estoque de segurança"
        outlined
        suffix="dias"
        @focus="$event.target.select()"
        @keyup.enter="salvarEsseg()"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { buscarFornecedor, salvarEssegPorFornecedor } from "./RequisicoesAPI";
import TextFieldFormatadorDeValor from '../../utils/TextFieldFormatadorDeValor.vue';

export default {
  name: "Fornecedor",
  components: { SysDialog, TextFieldFormatadorDeValor },
  props: {
    cobertura_selecionada: {
      type: Number
    },
    fornecedor: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    cobertura_esseg: null
  }),
  watch: {
    cobertura_selecionada(valor) {
      const validador = valor === 3;
      this.dialog = validador;
      if (validador) {
        const parametros = {
          id_fornecedor: this.fornecedor.id,
          ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          buscarFornecedor(parametros)
            .then(dado => this.cobertura_esseg = dado.tempo_cobertura_esseg)
        );
      }
    }
  },
  methods: {
    salvarEsseg() {
      const params = {
        id_grupo: this.$store.getters['usuario/getGrupoCompras'],
        id_fornecedor: this.fornecedor.id,
        tipo_esseg: this.cobertura_selecionada,
        valor_esseg: this.cobertura_esseg,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarEssegPorFornecedor(params)
          .then(() => {
            this.dialog = false;
            this.cobertura_esseg = null;
            this.$emit('fechar-dialog-fornecedor', true);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style>

</style>
